// Sample event data for testing Preview mode
// URL: /SampleData0725 (July 2025)

const sampleEventData = {
  // Event UUID and metadata
  eventId: 'SampleData0725',
  createdAt: '2025-07-15T10:00:00Z',
  lastModified: '2025-07-20T14:30:00Z',
  publishedAt: '2025-07-20T14:30:00Z',
  status: 'published',
  
  // Basic required fields
  eventTitle: 'Summer Chess Championship 2025',
  startDate: '2025-07-25',
  endDate: '2025-07-25',
  registrationLink: 'https://register.chess.com/summer-championship-2025',
  
  // Optional basic fields
  eventDescription: `Join us for the most exciting chess tournament of the summer! This championship welcomes players of all skill levels, from beginners to grandmasters. 

Experience competitive chess in a friendly environment with excellent prizes, professional arbitration, and top-notch facilities. Whether you're looking to improve your rating or just enjoy the game, this tournament offers something for everyone.

Special features include live game streaming, analysis rooms, and a simultaneous exhibition by a local master after the tournament concludes.`,
  
  registrationFee: '$45 (Students: $35, Seniors 65+: $30)',
  paymentInfo: 'Send payment to: PayPal - director@summerchess.com, Venmo - @SummerChessChampionship, or cash at check-in (exact change preferred)',
  prizeFund: '$2,500 total prizes - 1st: $800, 2nd: $500, 3rd: $300, 4th: $200, Best Junior: $150, Best Senior: $150, Best Upset: $100, Class prizes: $50 each',
  
  // Tournament format fields
  timeControl: '90 minutes + 30 second increment per move',
  rounds: '6 rounds',
  tournamentFormat: 'Swiss System',
  federation: 'USCF Rated',
  maxPlayers: '120 players',
  ratingSections: 'Open Section (no rating limit), Reserve Section (Under 1800), Scholastic Section (K-12)',
  
  // Tournament Sections with pricing (new unified structure)
  tournamentSections: [
    {
      id: 'open-section',
      name: 'Open Section',
      minRating: 0,
      maxRating: 3000,
      baseFee: 45,
      pricingTiers: [],
      extras: []
    },
    {
      id: 'u1800-section',
      name: 'U1800 Section',
      minRating: 0,
      maxRating: 1800,
      baseFee: 45,
      pricingTiers: [],
      extras: []
    },
    {
      id: 'scholastic-section',
      name: 'Scholastic Section (K-12)',
      minRating: 0,
      maxRating: 3000,
      baseFee: 35,
      pricingTiers: [],
      extras: []
    }
  ],
  
  // Administrative fields
  checkinTime: '9:00 AM - 9:45 AM (Players must check in 15 minutes before their first game)',
  tournamentDirector: 'International Arbiter Sarah Johnson (USCF Senior TD, FIDE Arbiter)',
  
  // New expansion fields
  primaryColorHex: '#10b981', // Green theme for this tournament
  registrationStatus: 'open', // Registration status for button logic
  resultsLink: 'https://chess-results.com/tnr789012.aspx?lan=1',
  scheduleLink: 'https://chess-results.com/tnr789012.aspx?lan=1&art=2',
  participants: [
    { id: 1, name: 'Alice Zhang', rating: 1821, section: 'open-section', paid: true },
    { id: 2, name: 'David Johnson', rating: 2103, section: 'open-section', paid: true },
    { id: 3, name: 'Luis Perez', rating: 1934, section: 'open-section', paid: true },
    { id: 4, name: 'Emma Wilson', rating: 1654, section: 'u1800-section', paid: true },
    { id: 5, name: 'Michael Chen', rating: 1743, section: 'u1800-section', paid: false },
    { id: 6, name: 'Sarah Kim', rating: 1456, section: 'u1800-section', paid: true },
    { id: 7, name: 'Robert Taylor', rating: 1234, section: 'scholastic-section', paid: true },
    { id: 8, name: 'Jessica Brown', rating: 1567, section: 'scholastic-section', paid: true },
    { id: 9, name: 'Thomas Anderson', rating: 1890, section: 'open-section', paid: true },
    { id: 10, name: 'Maria Garcia', rating: 1345, section: 'u1800-section', paid: true }
  ],
  
  // Venue information - separate fields for Home tab display
  venueName: 'Grand Ballroom, Riverside Convention Center',
  venueAddress: '123 Tournament Drive, Riverside, CA 92503',
  
  // Location details - separate fields for Location tab display
  parkingInfo: 'Free parking available in the convention center lot (enter from Oak Street)',
  publicTransit: 'Metro Line 15 stops directly at Convention Center (Oak Street Station). 25 minutes from Riverside Municipal Airport',
  nearbyHotels: 'Hampton Inn Riverside (2 blocks) - Tournament rate: $89/night, Holiday Inn Express (1.5 miles) - Tournament rate: $79/night, Comfort Suites (0.8 miles) - Tournament rate: $95/night',
  diningOptions: 'Convention Center Café (on-site), Tony\'s Pizza (across the street), Riverside Grill (3 blocks north), Multiple restaurants within walking distance',
  city: 'Toronto, Ontario, Canada',
  // Location information
  location: `Grand Ballroom, Riverside Convention Center
123 Tournament Drive, Riverside, CA 92503

Parking: Free parking available in the convention center lot (enter from Oak Street)
Public Transit: Metro Line 15 stops directly at Convention Center (Oak Street Station)
Airport: 25 minutes from Riverside Municipal Airport

Nearby Hotels:
- Hampton Inn Riverside (2 blocks) - Tournament rate: $89/night
- Holiday Inn Express (1.5 miles) - Tournament rate: $79/night
- Comfort Suites (0.8 miles) - Tournament rate: $95/night

Dining Options:
- Convention Center Café (on-site)
- Tony's Pizza (across the street)
- Riverside Grill (3 blocks north)
- Multiple restaurants within walking distance`,

  // Contact information
  contactInfo: `Tournament Director: Sarah Johnson
Email: tournament@riversidechess.org
Phone: (951) 555-CHESS (2437)
Text: (951) 555-0123

Registration Questions: registration@riversidechess.org
Website: www.riversidechess.org/summer-championship

Riverside Chess Club
President: Michael Chen - president@riversidechess.org
Vice President: Lisa Rodriguez - vp@riversidechess.org

For urgent matters during the tournament, contact the Tournament Director by phone or text.`,

  // Rules and format
  rules: `TOURNAMENT RULES & FORMAT

PAIRING SYSTEM:
- Swiss System pairing using Swiss-Manager software
- 6 rounds of play
- Players cannot be paired against the same opponent twice
- Bye requests must be submitted before round 1 starts

TIME CONTROL:
- 90 minutes per player + 30 second increment per move
- Digital clocks will be provided for all games
- Players may bring their own DGT or approved digital clock

TIEBREAK PROCEDURES:
1. Modified Median (Solkoff)
2. Cumulative (Progressive)
3. Opponent's Score
4. Head-to-head record
5. Coin flip (if necessary)

RATING SECTIONS:
- Open Section: All players welcome
- Reserve Section: Players rated under 1800 USCF
- Scholastic Section: K-12 students only

EQUIPMENT RULES:
- Standard tournament chess sets will be provided
- Players may bring their own USCF approved sets
- Pieces must be Staunton style, 3.75" king height
- Board squares must be 2.25" minimum
- Scoresheets and pencils provided

CONDUCT RULES:
- No talking during games except to offer draws or resign
- Cell phones must be turned off and stored away
- Players arriving more than 30 minutes late forfeit the game
- No outside analysis of games in progress
- Spectators must remain silent and maintain distance from boards

DRAW RULES:
- Draws may be offered after move 30
- 50-move rule and threefold repetition apply
- Insufficient material draws are automatic
- Stalemate is a draw

APPEALS PROCEDURE:
- Appeals must be made immediately to the Tournament Director
- Appeals fee: $25 (refunded if successful)
- TD decisions are final unless appealed to the USCF

BYE REQUESTS:
- Half-point byes available for rounds 1-5 (request before round 1)
- No byes available for the final round
- Players must play at least 4 games to be eligible for prizes

SPECIAL RULES:
- Photography/recording allowed with TD permission
- No food or drinks at the playing tables
- Smoking is prohibited in the tournament hall
- Players must dress appropriately (no shorts, tank tops, or flip-flops)`,

  // Custom section
  customName: 'Special Tournament Features',
  customHtml: `<div class="space-y-4">
    <h3 class="text-xl font-bold text-blue-700">🎯 What Makes This Tournament Special</h3>
    
    <div class="bg-yellow-50 border-l-4 border-yellow-400 p-4">
        <h4 class="font-semibold text-yellow-800">🏆 Enhanced Prize Structure</h4>
        <p class="text-yellow-700">Beyond traditional prizes, we offer special recognition for tactical brilliance, sportsmanship, and improvement over rating expectations.</p>
    </div>

    <div class="bg-green-50 border-l-4 border-green-400 p-4">
        <h4 class="font-semibold text-green-800">📱 Live Game Coverage</h4>
        <p class="text-green-700">Top board games will be streamed live on our website with expert commentary from FM Robert Williams.</p>
    </div>

    <div class="bg-blue-50 border-l-4 border-blue-400 p-4">
        <h4 class="font-semibold text-blue-800">🎓 Educational Opportunities</h4>
        <p class="text-blue-700">Free puzzle-solving session between rounds 3 and 4, plus post-tournament analysis with titled players.</p>
    </div>

    <div class="bg-purple-50 border-l-4 border-purple-400 p-4">
        <h4 class="font-semibold text-purple-800">🤝 Community Focus</h4>
        <p class="text-purple-700">Part of proceeds support local school chess programs. Join us in growing chess in our community!</p>
    </div>

    <div class="mt-6 p-4 bg-gray-100 rounded-lg">
        <h4 class="font-bold text-gray-800">📅 Tournament Schedule</h4>
        <ul class="list-disc list-inside text-gray-700 mt-2 space-y-1">
            <li>9:00 AM - Registration & Check-in</li>
            <li>9:45 AM - Opening Ceremony & Player Meeting</li>
            <li>10:00 AM - Round 1</li>
            <li>12:30 PM - Round 2</li>
            <li>3:00 PM - Round 3</li>
            <li>4:30 PM - Break & Puzzle Session</li>
            <li>5:30 PM - Round 4</li>
            <li>8:00 PM - Dinner break</li>
            <li>9:00 PM - Round 5</li>
            <li>11:30 PM - Round 6</li>
            <li>2:00 AM - Closing Ceremony & Prize Distribution</li>
        </ul>
    </div>
</div>`,

  // Registration information
  registrationInfo: `REGISTRATION DETAILS

REGISTRATION DEADLINE: July 20, 2025 at 11:59 PM
Late registration may be available on-site (subject to capacity) with a $10 late fee.

ENTRY FEES:
- Regular: $45
- Students (with valid ID): $35
- Seniors (65+): $30
- USCF members save additional $5

PAYMENT OPTIONS:
- Credit/Debit Cards (Visa, MasterCard, American Express)
- PayPal
- Cash or check at on-site registration (exact change preferred)
- Venmo: @RiversideChess

REQUIRED INFORMATION:
- Full name (as it appears on USCF card)
- USCF ID number and current rating
- Email address and phone number
- Emergency contact information
- Age (for youth and senior prizes)
- School name (for scholastic section)

USCF MEMBERSHIP:
- Current USCF membership required for all players
- Memberships available on-site: Adult $45, Youth $25, Senior $35
- Visit uschess.org to join online before the tournament

SPECIAL ACCOMMODATIONS:
- Wheelchair accessible venue
- Large print scoresheets available upon request
- Hearing assistance devices available
- Quiet room available for players with special needs
- Contact TD at least 48 hours before tournament for arrangements

REFUND POLICY:
- Full refund if tournament is cancelled
- 50% refund if withdrawal before July 15
- 25% refund if withdrawal before July 20
- No refunds after July 20 unless for medical emergency

WHAT TO BRING:
- Valid photo ID
- Current USCF membership card
- Chess set and clock (if preferred)
- Snacks and water bottle
- Light jacket (room may be cool)

WHAT NOT TO BRING:
- Electronic devices (phones must be off and stored)
- Outside food in playing area
- Noisy items
- Inappropriate attire`,

  // FAQ content
  faqContent: `Q: What is the time control for this tournament?
A: The time control is 90 minutes per player plus a 30-second increment per move. This means each player starts with 90 minutes, and after every move they make, they get an additional 30 seconds added to their remaining time.

Q: Do I need to bring my own chess set and clock?
A: No, chess sets and clocks will be provided for all games. However, you are welcome to bring your own USCF-approved equipment if you prefer.

Q: What happens if I arrive late for a round?
A: Players have a 30-minute grace period after the round starts. If you arrive more than 30 minutes late, you will forfeit that game. Your clock starts running at the scheduled round time regardless of when you arrive.

Q: Can I request a bye for a round?
A: Yes, you can request a half-point bye for rounds 1-5, but you must make this request before round 1 begins. No byes are available for the final round. You must play at least 4 games to be eligible for prizes.

Q: Are there separate sections for different skill levels?
A: Yes! We have three sections: Open Section (no rating limit), Reserve Section (under 1800 USCF), and Scholastic Section (K-12 students only). You'll compete against players of similar strength.

Q: How are prizes determined if players tie?
A: Prizes are awarded based on tiebreak systems: 1) Modified Median, 2) Cumulative score, 3) Opponent's score, 4) Head-to-head record, and 5) Coin flip if necessary.

Q: Can I analyze my games with other players or engines during the tournament?
A: No, analyzing ongoing games is strictly prohibited. However, you can discuss completed games quietly in designated areas between rounds.

Q: What should I do if I have a dispute during a game?
A: Immediately call the Tournament Director. Stop both clocks and wait for the TD to arrive. Don't continue playing until the dispute is resolved.

Q: Are there food and drinks available at the venue?
A: Yes, the Convention Center Café is on-site, and there are several restaurants within walking distance. However, no food or drinks are allowed at the playing tables.

Q: Can spectators watch the games?
A: Yes, spectators are welcome but must remain silent and maintain a respectful distance from the playing boards. Photography may be allowed with TD permission.

Q: What if I need to withdraw from the tournament?
A: Please notify the Tournament Director as soon as possible. Refunds are available based on our refund policy (see Registration section for details).

Q: Is the venue accessible for players with disabilities?
A: Yes, the venue is fully wheelchair accessible, and we can provide accommodations such as large print scoresheets or hearing assistance devices. Please contact us at least 48 hours before the tournament to arrange special accommodations.

Q: What should I wear to the tournament?
A: Please dress appropriately for a professional chess tournament. Business casual is recommended. Shorts, tank tops, and flip-flops are not permitted.

Q: How can I improve my chess before the tournament?
A: Practice tactics daily, study basic endgames, and play longer time control games online. Consider joining our local chess club for practice games and instruction.

Q: Will there be opportunities to meet other chess players?
A: Absolutely! There will be designated social areas, a puzzle-solving session between rounds, and post-tournament analysis with titled players. Many lifelong chess friendships begin at tournaments like this.`
};

export default sampleEventData; 